import Vue from 'vue'
import App from './App.vue'
import router from './router'

import '@/assets/styles/index.scss'
import '@/assets/common.css'
// 引入mock数据（开发环境自动启用）
import '@/utils/mock'

import confirm from '@/plugin/confirm'
import imagePreview from '@/plugin/imagePreview'
import empty from '@/components/business/empty.vue'
import backButton from '@/components/business/BackButton.vue'
import loading from '@/components/business/Loading.vue'
Vue.use(confirm)
Vue.use(imagePreview)
Vue.component('Empty', empty)
Vue.component('BackButton', backButton)
Vue.component('Loading', loading)
Vue.config.productionTip = false

// 全局错误处理 - 忽略导航取消和重复导航错误
Vue.config.errorHandler = (err, vm, info) => {
  // 忽略导航相关的错误
  if (err && (
    err.name === 'NavigationDuplicated' ||
    err.message?.includes('Navigation cancelled') ||
    err.message?.includes('Avoided redundant navigation')
  )) {
    return
  }
  // 其他错误正常处理
  console.error('Vue Error:', err, info)
}

// 移动端触摸优化 - 消除点击延迟
if ('ontouchstart' in window) {
  let lastTouchEnd = 0
  document.addEventListener('touchend', function (event) {
    const now = Date.now()
    if (now - lastTouchEnd <= 300) {
      event.preventDefault()
    }
    lastTouchEnd = now
  }, false)
}

// 捕获未处理的 Promise 错误
window.addEventListener('unhandledrejection', event => {
  const err = event.reason
  if (
    err &&
    (err.name === 'ChunkLoadError' ||
      /Loading chunk \d+ failed/.test(err.message))
  ) {
    window.location.reload()
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
